<wr-base-dialog status="danger"
                [header]="title"
                submitText="Löschen"
                (submit)="onDelete()"
                (close)="onCancel()">
  {{message}}
</wr-base-dialog>
